import {
  Instagram,
  Facebook,
  Twitter,
  Linkedin,
  Globe,
  Music2,
  Users,
  FileText,
  UserPlus,
  MapPin,
} from "lucide-react";

export const STATUSES = [
  { key: "new", label: "New", text: "text-blue-400", bg: "bg-blue-500/10", border: "border-blue-500/30", dot: "bg-blue-400", hex: "#3B82F6" },
  { key: "contacted", label: "Contacted", text: "text-amber-400", bg: "bg-amber-500/10", border: "border-amber-500/30", dot: "bg-amber-400", hex: "#F59E0B" },
  { key: "qualified", label: "Qualified", text: "text-purple-400", bg: "bg-purple-500/10", border: "border-purple-500/30", dot: "bg-purple-400", hex: "#8B5CF6" },
  { key: "closed_won", label: "Closed Won", text: "text-emerald-400", bg: "bg-emerald-500/10", border: "border-emerald-500/30", dot: "bg-emerald-400", hex: "#10B981" },
  { key: "closed_lost", label: "Closed Lost", text: "text-rose-400", bg: "bg-rose-500/10", border: "border-rose-500/30", dot: "bg-rose-400", hex: "#F43F5E" },
];

export const statusMeta = (key) => STATUSES.find((s) => s.key === key) || STATUSES[0];

export const SOURCE_ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  twitter: Twitter,
  linkedin: Linkedin,
  tiktok: Music2,
  web: Globe,
  referral: Users,
  csv: FileText,
  manual: UserPlus,
  google: MapPin,
};

export const SOURCES = [
  "instagram",
  "facebook",
  "twitter",
  "linkedin",
  "tiktok",
  "web",
  "referral",
  "manual",
  "google",
];

export const sourceIcon = (src) => SOURCE_ICONS[src] || Globe;

export const fmtMoney = (n) =>
  "$" + (Number(n) || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
};
